export default __webpack_public_path__ + "static/CTA_Hover-45f5e659f2170f9fd0074bc23d0269da.png";